<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-0">
            <!-- Header -->
            <template #header>
              <div class="d-flex justify-content-between align-items-center w-100">
                <span class="font-weight-bold">
                  {{ headerTitle }}
                </span>

                <div class="d-flex align-items-center">
               
   <b-spinner
                    small
                    v-if="dashboardLoading"
                    variant="primary">
                </b-spinner>

                  <span class="mr-2 font-weight-bold">All Shipments</span>

                  <b-form-checkbox
                      v-model="isQwik"
                      switch
                      class="mr-2"
                      :disabled="dashboardLoading"
                     >
                  </b-form-checkbox>

                  <span class="mr-3 font-weight-bold">QWIK Shipments</span>
               


                   <router-link
                     v-if="!isArchivePage && !isQwikPage"

                    :to="{ name: 'dashboard_adv', query: { status: 'archive' } }"
                    class="mr-4 text-primary font-weight-bold"
                  >
                    Archive ({{ archiveCount }})
                  </router-link>


                <!--
                  <router-link
                    v-if="!isArchivePage"
                    :to="{ name: 'dashboard_adv', query: { status: 'archive' } }"
                    class="mr-3 text-primary font-weight-bold"
                  >
                    Archive ({{ archiveCount }})
                  </router-link>

                  <router-link
                    v-else
                    :to="{ name: 'dashboard_adv' }"
                    class="mr-3 text-primary font-weight-bold"
                  >
                    Dashboard Summary
                  </router-link>

                  <router-link
                    :to="{ name:'dashboard_adv', params:{ id:'qwik' } }"
                    class="mr-3 text-success font-weight-bold">

                    QWIK Dashboard

                </router-link>-->

                  <span class="font-weight-bold">
                    Total AWB : {{ totalAwbCount }}
                  </span>
                </div>
              </div>
            </template>

            <!-- Dashboard Boxes -->
            <b-row class="boxto">
              <b-col
                v-for="item in dashboardItems"
                :key="item.label"
                sm="6"
                lg="2"
                class="pointer"
              >
                <b-card :class="item.bgClass" no-body>
                  <router-link
                    class="routelicount"
                    :to="{
                      name: 'dashboardAwblist',
                      params: { id: item.route + '-' + route_id },
                      query: { status: $route.query.status }
                    }"
                  >
                    <b-card-body class="pb-0">
                      <h4 class="mb-0 countfont text-center countcolor">
                        <span v-if="item.label === 'Delivered' && deliveredLoading">
                          <b-spinner small type="grow"></b-spinner>
                        </span>
                        <span v-else>
                          {{ item.count }}
                        </span>
                      </h4>

                      <p class="text-center countcolor">
                        {{ item.label }}
                      </p>
                    </b-card-body>
                  </router-link>
                </b-card>
              </b-col>

              <!-- No Data -->
              <b-col v-if="dashboardItems.every(i => i.count === 0)" cols="12">
                <p class="text-center text-muted py-4">
                  No dashboard data available
                    <b-spinner
                    small
                    v-if="dashboardLoading"
                    variant="primary">
                </b-spinner>
                </p>
              </b-col>
            </b-row>

          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'

export default {
  name: 'dashboard_adv',
  data() {
    return {
      route_id: null,
      bookingDonecount: 0,
      bookingPendingcount: 0,
      deliveredCount: 0,
      ofdCount: 0,
      dispatchOutScanCount: 0,
      partialDeliveredcount: 0,
      INTransit_Count: 0,
      ndrpendingCount: 0,
      hubInScanPendingCount: 0,
      hubInScanCount: 0,
      zoneInScanCount: 0,
      zoneOutScanCount: 0,
      pickDoneCount: 0,
      archiveCount: 0,
      deliveredLoading: true, // loader for Delivered only
      rtoCount: 0,
      rtoDlyShippingCount: 0,
      rtoNcCount: 0,
      rtoPickupCancelCount: 0,
      rtoEwaybillExpCount: 0,
      stockInwardCount: 0,
      itDamageCount: 0,
      lostCount: 0,
      dashboardLoading: false


    }
  },
  computed: {
      totalRtoCount() {
        return (
          Number(this.rtoCount || 0) +
          Number(this.rtoDlyShippingCount || 0) +
          Number(this.rtoNcCount || 0) +
          Number(this.rtoPickupCancelCount || 0) +
          Number(this.rtoEwaybillExpCount || 0)
        )
      },
      isQwik: {
        get() {
          return this.route_id === 'qwik';
        },
        set(val) {
          const target = val ? 'qwik' : 'normal';
          if (target === this.route_id) return;
          this.$router.push({
            name: 'dashboard_adv',
            params: { id: target },
            query: this.$route.query
          });
        }
      },
      isArchivePage () {
        return this.$route.query.status === 'archive'
      },
      isQwikPage() {
          return this.route_id === 'qwik'
      },
      headerTitle () {
       if (this.isArchivePage)
        return 'Archive Summary';

      if (this.isQwikPage)
        return 'QWIK Dashboard';

      return 'Dashboard Summary';

      
      },
      totalAwbCount () {
      return (
        Number(this.bookingDonecount || 0) +
        Number(this.bookingPendingcount || 0) +
        Number(this.deliveredCount || 0) +
        Number(this.ofdCount || 0) +
        Number(this.dispatchOutScanCount || 0) +
        Number(this.partialDeliveredcount || 0) +
        Number(this.INTransit_Count || 0) +
        Number(this.ndrpendingCount || 0) +
        Number(this.hubInScanPendingCount || 0) +
        Number(this.hubInScanCount || 0) +
        Number(this.zoneInScanCount || 0) +
        Number(this.zoneOutScanCount || 0) +
        Number(this.pickDoneCount || 0)+
        Number(this.totalRtoCount || 0)

      )
    },

    dashboardItems() {
      return [
        {
          label: 'Booking Pending',
          count: this.bookingPendingcount,
          tooltipCount: 'Booking Pending Count',
          tooltipLabel: 'Booking Pending',
          bgClass: 'bg-aqua',
          route: 'BookingPending',
        },
        {
          label: 'Booking Done',
          count: this.bookingDonecount,
          tooltipCount: 'Booking Done Count',
          tooltipLabel: 'Booking Done',
          bgClass: 'bg-purpal',
          route: 'BookingDone',
        },
        {
          label: 'Pick Done',
          count: this.pickDoneCount,
          tooltipCount: 'Pick Done Count',
          tooltipLabel: 'Pick Done',
          bgClass: 'bg-blue',
          route: 'PickDone',
        },
        {
          label: 'Hub InScan Pending',
          count: this.hubInScanPendingCount,
          tooltipCount: 'Hub InScan Pending Count',
          tooltipLabel: 'Hub InScan Pending',
          bgClass: 'bg-indigo',
          route: 'HubInScanPending',
        },
        {
          label: 'Hub InScan',
          count: this.hubInScanCount,
          tooltipCount: 'Hub InScan Count',
          tooltipLabel: 'Hub InScan',
          bgClass: 'bg-cyan',
          route: 'HubInScan',
        },
        {
          label: 'Zone InScan',
          count: this.zoneInScanCount,
          tooltipCount: 'Zone InScan Count',
          tooltipLabel: 'Zone InScan',
          bgClass: 'bg-lime',
          route: 'ZoneInScan',
        },
        {
          label: 'Zone OutScan',
          count: this.zoneOutScanCount,
          tooltipCount: 'Zone OutScan Count',
          tooltipLabel: 'Zone OutScan',
          bgClass: 'bg-brown',
          route: 'ZoneOutScan',
        },      
        {
          label: 'DispatchOutScan',
          count: this.dispatchOutScanCount,
          tooltipCount: 'Dispatch Out Scan Count',
          tooltipLabel: 'Dispatch Out Scan',
          bgClass: 'bg-def',
          route: 'DispatchOutScan',
        },
        {
          label: 'InTransit',
          count: this.INTransit_Count,
          tooltipCount: 'InTransit Count',
          tooltipLabel: 'InTransit',
          bgClass: 'bg-teal',
          route: 'INTransit',
        },
        {
          label: 'Pick Up(OFD)',
          count: this.ofdCount,
          tooltipCount: 'Pick Up Count(OFD)',
          tooltipLabel: 'Pick Up',
          bgClass: 'bg-def',
          route: 'OFD',
        },  
        {
          label: 'Delivered',
          count: this.deliveredCount,
          tooltipCount: 'Delivered Count',
          tooltipLabel: 'Delivered',
          bgClass: 'bg-green',
          route: 'Delivered',
        },
         {
          label: 'Partial Delivered',
          count: this.partialDeliveredcount,
          tooltipCount: 'Partial Delivered Count',
          tooltipLabel: 'Partial Delivered',
          bgClass: 'bg-pink',
          route: 'PartialDelivered',
        },
        {
          label: 'NDR',
          count: this.ndrpendingCount,
          tooltipCount: 'NDR',
          tooltipLabel: 'NDR',
          bgClass: 'bg-red',
          route: 'NDR',
        },
       {
          label: 'RTO',
          count: this.totalRtoCount,
          tooltipCount: 'Total RTO Count',
          tooltipLabel: 'Return to Origin',
          bgClass: 'bg-warning',
          route: 'RTO',
        },
      
        {
          label: 'IT Damage',
          count: this.itDamageCount,
          tooltipCount: 'IT Damage Count',
          tooltipLabel: 'IT Damaged',
          bgClass: 'bg-dark',
          route: 'IT-DMG',
        },
        {
          label: 'Lost',
          count: this.lostCount,
          tooltipCount: 'Lost Count',
          tooltipLabel: 'Lost Shipment',
          bgClass: 'bg-info',
          route: 'Lost',
        }

        
      ]
    }
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userData") || '{}')
    this.route_id = this.$route.params.id || 'normal'
    this.isQwik = this.route_id === 'qwik';
    this.displayDashboardData()
  },
  watch: {
  '$route.params.id': {
    immediate: true,
    handler(id) {
      this.route_id = id || 'normal';
      this.displayDashboardData();
    }
  }
},
  methods: {
     
    displayDashboardData() {
        this.dashboardLoading = true;

        this.deliveredLoading = true;

      const dashobj = {
        is_asn: this.route_id === 'normal' ? 'NO' : 'YES',
        status: this.$route.query.status || '',
        order_type: this.route_id === 'qwik' ? 'qwik' : ''
      }
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashBoardAwbCount`, dashobj)
        .then(result => {
          const data = result.body.returnvalue.ParentAWB
           this.bookingDonecount = data.BookingDone || 0
          this.bookingPendingcount = data.BookingPending || 0
          this.deliveredCount = data.Delivered || 0
          this.ofdCount = data.OFD || 0
          this.dispatchOutScanCount = data.DispatchOutScan || 0
          this.partialDeliveredcount = data.partialDLV || 0
          this.INTransit_Count = data.INTransit || 0
          this.ndrpendingCount = data.NDR || 0
          this.hubInScanPendingCount = data.HubInScanPending || 0
          this.hubInScanCount = data.HubInScan || 0
          this.zoneInScanCount = data.ZoneInScan || 0
          this.zoneOutScanCount = data.ZoneOutScan || 0
          this.pickDoneCount = data.PickDone || 0
          this.archiveCount = data.archive || 0
          this.rtoCount = data.RTO || 0;
          this.rtoDlyShippingCount = data['RTO-DLY-SHIPPING'] || 0;
          this.rtoNcCount = data['RTO-NC'] || 0;
          this.rtoPickupCancelCount = data['RTO-PKUP-CAN'] || 0;
          this.rtoEwaybillExpCount = data['RTO-eWayBill-EXP'] || 0;
          this.stockInwardCount = data.StockInward || 0;
          this.itDamageCount = data['IT-DMG'] || 0;
          this.lostCount = data.Lost || 0;
          console.log("Total AWB Count:", this.totalAwbCount);
          if (this.$route.query.status === 'archive') {
            this.deliveredLoading = false; 
            return; 
          }else{
            return this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashBoardAwbDelievryCount`, dashobj);
              
          }
          }).then(result2 => {
            const data2 = result2.body.returnvalue.ParentAWB; // adjust if API response structure differs
            this.deliveredCount = data2.Delivered;
          }).finally(() => {
            this.deliveredLoading = false; 
            this.dashboardLoading = false;
          }).catch(error => {
            console.error("Error fetching dashboard AWB counts:", error);
            this.dashboardLoading = false;
          });
    }
  }
}
</script>

<style scoped>
/* ===== Card Backgrounds ===== */
.bg-aqua { background:#00c0ef !important; color:#fff; }
.bg-green { background:#28a745 !important; color:#fff; }
.bg-yellow { background:#f39c12 !important; color:#fff; }
.bg-pink { background:#e83e8c !important; color:#fff; }
.bg-purpal { background:#6f42c1 !important; color:#fff; }
.bg-red { background:#dc3545 !important; color:#fff; }
.bg-def { background:#17a2b8 !important; color:#fff; }
.bg-teal { background:#20c997 !important; color:#fff; }
.bg-orange { background:#fd7e14 !important; color:#fff; }
.bg-indigo { background:#6610f2 !important; color:#fff; }
.bg-cyan { background:#0dcaf0 !important; color:#000; }
.bg-lime { background:#84cc16 !important; color:#000; }
.bg-brown { background:#795548 !important; color:#fff; }
.bg-dark { background:#343a40 !important; color:#fff; }
.bg-blue { background:#0d6efd !important; color:#fff; }

/* ===== Card Layout ===== */
.boxto .card-body {
  padding: 0 !important;
}

.routelicount {
  display: block;
  padding: 18px 0;
  text-decoration: none;
}

/* ===== Text ===== */
.countcolor {
  color: white !important;
}

.countfont {
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 1.2;
}

/* ===== Cursor States ===== */
.pointer {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed;
  opacity: 0.6;
  margin-top: 18px;
  margin-bottom: 1rem;
}

/* ===== Hover Effects (Desktop only) ===== */
@media (hover: hover) {
  [class^="bg-"]:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25);
  }
}

[class^="bg-"] {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

/* ===== Responsive Adjustments ===== */
@media (max-width: 992px) {
  .countfont {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .countfont {
    font-size: 1.8rem;
  }

  .routelicount {
    padding: 14px 0;
  }
}

@media (max-width: 576px) {
  .countfont {
    font-size: 1.6rem;
  }

  .routelicount {
    padding: 12px 0;
  }
}
.dashboard-overlay{
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background:rgba(255,255,255,.75);
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    z-index:100;
}

</style>
